const InteractionEventName = {};
export default InteractionEventName;

InteractionEventName.LEVEL_STARTED = "level_started";
InteractionEventName.ITEM_SELECTED = "item_selected";
InteractionEventName.LEVEL_ENDED = "level_ended";